/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./n20Card.vue?vue&type=template&id=639e690a&scoped=true&"
import script from "./n20Card.vue?vue&type=script&lang=js&"
export * from "./n20Card.vue?vue&type=script&lang=js&"
import style0 from "./n20Card.vue?vue&type=style&index=0&id=639e690a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e690a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardActions,VCardText,VDivider,VIcon})
